import { render, staticRenderFns } from "./GNotifications.vue?vue&type=template&id=ff1a3ca0&"
import script from "./GNotifications.vue?vue&type=script&lang=ts&"
export * from "./GNotifications.vue?vue&type=script&lang=ts&"
import style0 from "./GNotifications.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports